import { render, staticRenderFns } from "./UiSaveSearchButton.vue?vue&type=template&id=220be0c0&"
import script from "./UiSaveSearchButton.vue?vue&type=script&lang=ts&"
export * from "./UiSaveSearchButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports